module.exports = __webpack_public_path__ + "img/advantage_two.ef32ce48.png";